import type { MilkdownPlugin } from '@milkdown/kit/ctx';

import { attachmentPlugins } from './attachment';
import { codeInlineCompatMark, emCompatMark, strikethroughCompatMark } from './marks';
import { platformPersistMarkNormalizer } from './normalizePlugin';
import { platformTableCompatNodes, platformTableContentSchema, platformTableNormalizer, platformTablePlugins } from './tables';

export {
  attachmentPlugins,
  codeInlineCompatMark,
  emCompatMark,
  strikethroughCompatMark,
  platformPersistMarkNormalizer,
  platformTableCompatNodes,
  platformTableContentSchema,
  platformTableNormalizer,
};

/** Platform-named marks/nodes; safe to register in all modes (readonly article render, standalone, collab). */
export const platformPersistMarks = [
  codeInlineCompatMark,
  strikethroughCompatMark,
  emCompatMark,
  ...platformTableCompatNodes,
  platformTableContentSchema,
  ...attachmentPlugins,
] as unknown as MilkdownPlugin[];

export function getPlatformPersistPlugins(options: { enableNormalizer: boolean }): MilkdownPlugin[] {
  return options.enableNormalizer
    ? [...platformPersistMarks, platformPersistMarkNormalizer, ...platformTablePlugins]
    : platformPersistMarks;
}
